import React from "react";
import styled from "theme/libs/styled";
import transformColor from "theme/libs/wordpress/utils/transformColor";
import { useSelector } from "react-redux";
import { useTheme } from "emotion-theming";

const ColorBackground = styled("div")``;

const ImageBackground = styled("div")`
    background-repeat: repeat;
`;

const SiteBackground = ({ children }) => {
    const { colors } = useTheme() ?? {};
    const [siteBackground] =
        useSelector(({ application }) => application.config?.options?.settings?.site_background) || [];

    const isCheckout = useSelector(({ page }) => page.type === "storm_checkout");

    switch (siteBackground?.layout) {
        case "color":
            const colorCode = transformColor(siteBackground.background_color);
            const backgroundColor = colors?.[colorCode] ?? colors.lightGreige;

            return <ColorBackground backgroundColor={backgroundColor}>{children}</ColorBackground>;
        case "image":
            const imageSrc = siteBackground.background_image.image.url;
            const imageWidth = `${siteBackground.background_image.image.meta.width}px`;
            const imageHeight = `${siteBackground.background_image.image.meta.height}px`;

            return (
                <ImageBackground backgroundImage={`url('${imageSrc}')`} backgroundSize={`${imageWidth} ${imageHeight}`}>
                    {children}
                </ImageBackground>
            );
        default:
            return (
                <ColorBackground backgroundColor={isCheckout ? colors.bg_grey : colors.white}>
                    {children}
                </ColorBackground>
            );
    }
};

export default SiteBackground;
